export const APP_LOCALE = 'IRT-Locale';
